import { render, staticRenderFns } from "./KgCollapse.vue?vue&type=template&id=23cbdb20&scoped=true"
import script from "./KgCollapse.vue?vue&type=script&lang=js"
export * from "./KgCollapse.vue?vue&type=script&lang=js"
import style0 from "./KgCollapse.vue?vue&type=style&index=0&id=23cbdb20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cbdb20",
  null
  
)

export default component.exports